import * as _4 from 'lodash4';
import { IRegFormOutput } from '../builders/section_registraion_attributes_builder';
export class RegistrationAttributesServant {
  static sectionSeperatorChar = '_';

  static formRegAttributeApiParamFromFormOutput(formOutput: Record<string, any>): IRegFormOutput {
    const differentSectionParams = {};
    for (const key in formOutput) {
      const sectionIdSeparatorIndex = key.lastIndexOf(RegistrationAttributesServant.sectionSeperatorChar);
      const sectionId = key.slice(sectionIdSeparatorIndex + 1, key.length);
      const paramKey = key.slice(0, sectionIdSeparatorIndex);
      if (!differentSectionParams[sectionId]) {
        differentSectionParams[sectionId] = {};
      }
      differentSectionParams[sectionId][paramKey] = formOutput[key];
    }
    if (_4.isEmpty(differentSectionParams)) {
      return {};
    }
    return {
      auxiliary_attributes_by_section: differentSectionParams
    };
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/registration_attributes/servants/registration_attributes_servant.ts